// LOAD-BEARING SIDE-EFFECT IMPORT — do not delete as "unused".
// The hub import warmed the Rematch model cluster; this specifier restores
// that init order. It retires with the Z2 codemod.
import '@/pages/api/scribeAPIV2';

import { useIsHeidi2OptInEnabled } from '@/app-shell/flags/agents-flags';
import { useIsHeidi2TrialEndEnabled } from '@/app-shell/flags/growth-flags';
import {
  TopStripPriority,
  useClaimTopStrip,
  useReportTopStrip,
} from '@/atoms/top-strip-atoms';
import { useIsClinicalRecordingActive } from '@/hooks/useIsClinicalRecordingActive';
import {
  trackComplimentaryTrialEndBannerClick,
  trackComplimentaryTrialEndBannerViewed,
} from '@/models/analytics/features/complimentary-trial-end-analytics';
import { isAppleCompliantBuild } from '@/utils/appConfiguration';
import {
  ComplimentaryTrialEndBanner,
  type ComplimentaryTrialEndBannerPorts,
} from '@heidi/commerce';
import { getUsageLimitsHelpUrl } from '@heidi/commerce/data';
import { useMutateMarkModalAsViewed } from '@heidi/workspace/data';

import { useOpenHomeTasks } from './use-open-home-tasks';

// The running timer lives in the Rematch store; the session and Chronicle
// signals already cover a recording in progress, paused or not.
const useIsRecordingActive = () => useIsClinicalRecordingActive(false);

const useMarkModalAsViewed = () => useMutateMarkModalAsViewed().mutate;

const useClaimComplimentaryTrialEndTopStrip = (isEligible: boolean) =>
  useClaimTopStrip(
    'complimentary-trial-end',
    TopStripPriority.COMPLIMENTARY_TRIAL_END,
    isEligible
  );

const COMPLIMENTARY_TRIAL_END_BANNER_PORTS: ComplimentaryTrialEndBannerPorts = {
  useIsHeidi2OptInEnabled,
  useIsHeidi2TrialEndEnabled,
  useReportTopStrip,
  useClaimTopStrip: useClaimComplimentaryTrialEndTopStrip,
  useIsClinicalRecordingActive: useIsRecordingActive,
  useOpenHomeTasks,
  useMarkModalAsViewed,
  isAppleCompliantBuild,
  getUsageLimitsHelpUrl,
  trackComplimentaryTrialEndBannerViewed,
  trackComplimentaryTrialEndBannerClick,
};

/** Layout strip for the last week of complimentary Heidi II Max usage. */
export const ComplimentaryTrialEndBannerHost = () => (
  <ComplimentaryTrialEndBanner ports={COMPLIMENTARY_TRIAL_END_BANNER_PORTS} />
);
